// extracted by mini-css-extract-plugin
export default {"setInfo":"CompanyAbout_setInfo__m47Hq","setDivLeft":"CompanyAbout_setDivLeft__nUx8z","setDivRight":"CompanyAbout_setDivRight__TIPyv","img":"CompanyAbout_img__-90Ai"};